query getEmailSendSummary($id: String) {
    getEmailSendSummary(id: $id) {
        status
        email_count
    }
}

